<template>
    <div>
      <div class="p-2" :style="skin.my_account.menu_item_border">
        <h5>{{translate("Recharge")}}</h5>
      </div>
      <div class="pb-2 font-size-custom mb-2 my-1 d-flex justify-content-center w-100">
                                <select v-model="selectedMethod" class="form-control input-login mr-sm-2 my-sm-0">
                                    <option disabled value="">{{ translate('choose_method') }}</option>
                                    <option v-for="method in methods" :key="method" :value="method">
                                        {{ method }}
                                    </option>
                                </select>
                            </div>
      <div v-if="selectedMethod == 'PIX'">
                                <form @submit.prevent="payment_pix" class="p-1 my-3">
                                    <!-- Selección de moneda -->
                                    <!-- <div class="pb-2 font-size-custom mb-2 my-1 d-flex justify-content-center w-100">
                                        <select v-model="selectedCard" @change="handleCurrencyChange"
                                            class="form-control input-login mr-sm-2 my-sm-0">
                                            <option disabled value="">{{ translate('choose_card') }}</option>
                                            <option v-for="card in cards" :key="card" :value="card">
                                                {{ card }}
                                            </option>
                                        </select>
                                    </div> -->
                                    <h4 :style="skin.my_account.menu_item_border" style="font-size: 12px;">AMOUNT IN BRL</h4>
                                    <div class="pb-2 font-size-custom mb-2 my-1 d-flex justify-content-center w-100">
                                        <input v-model="amount" id="destinationTagW" type="number" step="0.01"
                                            min="0.01" :placeholder="translate('Amount')"
                                            class="form-control input-login mr-sm-2  my-sm-0" autocomplete="off"
                                            required>
                                    </div>
                                    <div class="pb-2 font-size-custom mb-2 my-1 d-flex justify-content-center w-100">
                                        <input v-model="tax_id" id="destinationTag" type="number"
                                            :placeholder="translate('Identification Number')"
                                            class="form-control input-login mr-sm-2  my-sm-0" autocomplete="off"
                                            required>
                                    </div>
                                    <div class="pb-2 font-size-custom mb-2 my-1 d-flex justify-content-center w-100">
                                        <input v-model="cardName" id="destinationTag" type="text"
                                            :placeholder="translate('Name')"
                                            class="form-control input-login mr-sm-2  my-sm-0" autocomplete="off"
                                            required>
                                    </div>
                                    <div class="pb-2 font-size-custom mb-2 my-1 d-flex justify-content-center w-100">
                                        <input v-model="last_name" id="destinationTag" type="text"
                                            :placeholder="translate('Last Name')"
                                            class="form-control input-login mr-sm-2  my-sm-0" autocomplete="off"
                                            required>
                                    </div>
                                    <div class="pb-2 font-size-custom mb-2 my-1 d-flex justify-content-center w-100">
                                        <input v-model="cardEmail" id="destinationTag" type="text"
                                            :placeholder="translate('Email')"
                                            class="form-control input-login mr-sm-2  my-sm-0" autocomplete="off"
                                            required>
                                    </div>
                                    <div class="d-flex mb-0 align-content-center justify-content-center">
                                        <button id="submit_btnp" type="submit" class="btn p-0 login-btn"
                                            :style="{ 'background-color': skin.main_modal_background, 'color': skin.main_modal_text }"
                                            style="color:black;width: 50%;" :disabled="login_inProcess">
                                            <span v-if="loading">
                                                <i class="fas fa-spinner fa-spin"></i> <!-- Spinner -->
                                            </span>
                                            <span v-else>
                                                {{ translate('Do Payment') }}
                                            </span> </button>
                                    </div>
                                    <!-- <strong style="color:darkgray;" class="mb-3">Use the code only for one transaction,
                                        to make another get a new address</strong> -->
                                </form>
                            </div>
      <div v-if="response.result=='Ok'" class="alert alert-success  fade show" role="alert">
        {{ response.msg }}
      </div>
      <div v-if="response.result=='error'" class="alert alert-danger  fade show" role="alert">
        {{ response.msg }}
      </div>
      <!-- <div class="row p-2" v-if="!skin.my_account.user_recharge.custom_text.enabled">
          <form @submit.prevent="confirmRecharge()" class="col-12 col-lg-6 col-sm col-md">
            <div class="py-2">
              <label for="amount">{{translate("deposit_amount")}}</label>
              <input v-model="amount" type="number" step="1" class="form-control" placeholder="0" id="amount" required>
            </div>
            <div v-if="skin.my_account.user_recharge.payment_gateways.length > 1" class="py-2">
              <label for="gateway">{{translate("payment_gateway")}}</label>
              <select v-model="payment_gateway" class="form-select" id="gateway">
                <option value="select" disabled>{{translate("select_gateway")}}</option>
                <option v-for="(gateway, index) in skin.my_account.user_recharge.payment_gateways" :key="index" :value="gateway">{{ gateway.toUpperCase() }}</option>
              </select>
            </div>
            <div class="py-4">
              <button type="submit" :style="skin.qbet.booking_btn" class="p-2 text-center mb-2" style="width:100%;color:white" :disabled="recharge_inProcess">{{translate("confirm")}}</button>
            </div>
          </form>
      </div>
      <div v-else>
        <p v-html="skin.my_account.user_recharge.custom_text.text"></p>
      </div> -->
    </div>
  </template>
  
  <script>
  import axios from 'axios';
  export default {
      name:"user_recharge",
      props:["skin","language","translation"],
      data(){
        return{
          recharge_inProcess:false,
          amount:0,
          payment_gateway:"select",
          response:{result:"",msg:""},
          cardEmail: '',
            last_name:'',
            "tax_id": "",
            usuTelefono: "",
            usuTipdoc: "CC",
            cardName: '',
            amount: 5000.00,
            cardCVV: '123',
            cardYear: '08',
            cardMonth: '28',
            cardNumber: '1234123412341234',
            intervalId: null,
            login_inProcess: false,
            slectedCountry: '',
            selectedCurrency: '', // Moneda seleccionada
            selectedCard: '',
            destinationTag: '',
            loading: false,
            selectedBank: {},
            selectedMethod: '',
            methods: ['PIX'],

        }
      },
      methods:{
        async confirmRecharge(){
            try {
              if(this.user.user_data.data.min_recharge?(this.amount<this.user.user_data.data.min_recharge?true:false):this.amount<10?true:false){
                  this.response.result="error";
                  this.response.msg=this.translate("min_recharge")+" "+(this.user.user_data.data.min_recharge??10)+" "+this.user.user_data.data.currency;
                  return;
              }
              this.recharge_inProcess = true;
              let provider = this.payment_gateway!="select"?this.payment_gateway:this.$props.skin.my_account.user_recharge.payment_gateways[0];
              let type = provider=="asaas"||provider=="2gobank"?"PIX":"";
              let data = {
                  "amount":this.amount,
                  "currency":this.user.user_data.data.currency,
                  "type":type,
                  "provider":provider.toUpperCase()
              }
              const response = await axios.post(this.user.domain+'/orden/create?access_token='+this.user.token+'&site='+this.user.site,data);
              if(response.data.status == 1){
                if(response.data.url.type=="modal"){
                  let modal = document.getElementById('bookingModalBtn');
                  modal.click();
                  this.$root.$emit('newAlert',{
                    label: this.translate("Recharge")+" "+this.amount+" "+this.user.user_data.data.currency,
                    message: '<img src="'+response.data.url.link+'" alt="qrCode" style="width:100%">'+
                  '<div><p style="font-size:small;">'+this.translate("pix_disclaimers")+'</p></div>',
                    barCode: ''
                  });
                  this.response.result="Ok";
                  this.response.msg=response.data.message;
                  this.amount="";
                }
                else if(response.data.url.type=="tab"){
                  this.response.result="Ok";
                  this.response.msg=response.data.message;
                  this.amount="";
                  window.open(response.data.url.link, '_blank').focus();
                }
              }
              else if(response.data.status == 0){
                  this.response.result="error";
                  this.response.msg=response.data.message;
              }
              this.recharge_inProcess = false;
            } catch (error) {
              this.recharge_inProcess = false;
              this.response.result="error";
              this.response.msg=error.message;
            }
        },
        async payment_pix() {
            // console.log('credit_card')
            // console.log(this.slectedCountry)
            let data = {tax_id: this.tax_id, email: this.cardEmail, first_name: this.cardName, last_name: this.last_name}
            // if (!this.selectedCurrency) {
            //     this.status.message = this.translate("choose_currency");
            //     this.status.type = "danger";
            //     return;
            // }
            this.loading = true;
            // Lógica de envío a la store de Vuex
            await this.$store.dispatch('setPixdata', {data,amount: this.amount});
            // this.$store.commit("getPayment", {});
            setTimeout(async () => {
                await this.$store.dispatch("getPixPayment");
                this.loading = false;
            }, 500);
        },
        translate(text) {
          if(text){
            if (this.$props.translation[text]) {
              return this.$props.translation[text][this.$props.language];
            }
            else{
              var new_text_serched = text.replace(/ /g, "_");
              if (this.$props.translation[new_text_serched]) {
                return this.$props.translation[new_text_serched][this.$props.language];
              }
            }
            return text;
          }
        },
      },
      computed:{
        user(){
          return this.$store.getters['getUserData'];
        },
      },
      watch:{
        amount(newVal){
            if(newVal!=""){
              this.response ={result:"",msg:""};
              this.amount = Math.round(newVal);
            }
        }
      },
      mounted(){
      this.$store.dispatch('setPayment')
    }
  }
  </script>
  
  <style>
  
  </style>